import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { Provider } from "react-redux";

import store from "./Reducers/store";

import "./Assets/fonts/index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// const basePath = "/";

const router = createBrowserRouter([
  // {
  //   path: `${basePath}`,
  //   element: <App />,
  // },
  {
    path: "*",
    element: <App />,
  },
]);

root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);
